import { Role } from '../helpers/role';
import { castIdRouteParams } from '../helpers/helpers';

export default [
    {
        path: '/planning/list',
        name: 'planningList',
        component: () => import('../views/planning/List.vue'),
        meta: { claims: [{ name: 'planning', crud: 'read' }] }
    },
    {
        path: '/planning',
        name: 'planning',
        component: () => import('../views/planning/Planning.vue'),
        meta: { claims: [{ name: 'planning', crud: 'read' }] }
    },
    {
        path: '/organizationalProposals',
        name: 'organizationalProposals',
        component: () => import('../views/proposals/OrganizationalProposals'),
        meta: { claims: [{ name: 'planning', crud: 'read' }] }
    }
]
